import { links_meta } from 'z3k-parser/lib/find-links';
import { rusDateTime } from 'webui/utils/time';
import { isArray } from 'utils';
import { parsePhysicalIO } from 'z3k-parser/lib/input-outputs/utils';
function searchItem(key, item, search_value) {
    if (item == null) {
        return null;
    }
    switch (typeof item) {
        case 'string':
            if (item.toLowerCase().includes(search_value))
                return item;
            return null;
        case 'number':
            if (keys_of_physical_io.includes(key)) {
                const { block_id, input_number } = parsePhysicalIO(item);
                if (block_id?.toString().includes(search_value))
                    return item;
                if (input_number?.toString().includes(search_value))
                    return item;
            }
            if (item.toString().includes(search_value))
                return item;
            return null;
        case 'boolean':
            return null;
        case 'object':
            if (isArray(item)) {
                const temp = item
                    .map((val, i) => {
                    if (val == null) {
                        return null;
                    }
                    const result = searchItem(i.toString(), val, search_value);
                    if (val != null &&
                        typeof val === 'object' &&
                        'id' in val &&
                        result != null)
                        return { ...result, id: val.id, ...val };
                    return result;
                })
                    .filter((item) => item != null);
                return temp.length > 0 ? temp : null;
            }
            else {
                const temp = searchInZ3kConfig(item, search_value);
                return temp.length > 0 ? Object.fromEntries(temp) : null;
            }
        default:
            return null;
    }
}
export function searchInZ3kConfig(z3k_config, search_value) {
    const array_from_config = Object.entries(z3k_config);
    if (search_value === '') {
        return array_from_config;
    }
    const result = [];
    for (const [key, value] of array_from_config) {
        const search_result = searchItem(key, value, search_value);
        if (search_result != null) {
            if (isArray(search_result) && search_result.length > 0) {
                result.push([key, search_result]);
            }
            else
                result.push([key, search_result]);
        }
        else {
            if (key.toLowerCase().includes(search_value)) {
                result.push([key, value]);
            }
        }
    }
    return result;
}
function onlyUnique(array) {
    return [...new Set(array)];
}
function getLinkKeysFromZ3kConfig(link_type) {
    return onlyUnique(links_meta.flatMap((link_meta) => Object.entries(link_meta.links)
        .filter(([, _link_type]) => _link_type.type === link_type)
        .map(([linkPath]) => linkPath.split('.'))));
}
export const keys_with_link_list = getLinkKeysFromZ3kConfig('direct')
    .filter((path) => path[path.length - 1] == '[]')
    .map((path) => path[path.length - 2]);
export const keys_with_link = getLinkKeysFromZ3kConfig('direct')
    .filter((path) => path[path.length - 1] != '[]')
    .map((path) => path[path.length - 1]);
export const keys_of_physical_io = getLinkKeysFromZ3kConfig('physical_io')
    .filter((path) => path[path.length - 1] != '[]')
    .map((path) => path[path.length - 1]);
export const keys_for_convert_to_bytes = [
    'setting_register',
    'logged_parameter_register',
    'flag',
    'status',
    'action_register',
    'onguard',
    'state_flags',
];
export function get_history_configs_values(history_configs) {
    return history_configs.map((date, index) => {
        return {
            id: index,
            data: rusDateTime(new Date(date.time)),
        };
    });
}
